/* Trainingsplan-Editor (W3.1, 29.10.2026): dieselben Endpunkte im CRM (/api/trainingsplaner) und auf /coach
   (/api/coach/planer). `client` = axios-Instanz der Seite, `basis` = Pfad davor ('/trainingsplaner' bzw. '/planer'). */

export const fehlerText = (e, rest) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return rest;
};

export function planerApi(client, basis) {
  const p = (x) => `${basis}${x}`;
  return {
    plan: (id) => client.get(p(`/plaene/${id}`)),
    vorschau: (id, woche) => client.get(p(`/plaene/${id}/vorschau`), { params: { woche } }),
    neu: (body) => client.post(p('/plaene'), body),
    duplizieren: (id, body) => client.post(p(`/plaene/${id}/duplizieren`), body),
    alsVorlage: (id, body) => client.post(p(`/plaene/${id}/als-vorlage`), body),
    archivieren: (id, version) => client.post(p(`/plaene/${id}/archivieren`), { version }),
    freigeben: (id, version) => client.post(p(`/plaene/${id}/freigeben`), { version }),
    name: (id, version, name) => client.patch(p(`/plaene/${id}/name`), { version, name }),
    personen: (id, version, athleten_ids) => client.patch(p(`/plaene/${id}/personen`), { version, athleten_ids }),
    tagNeu: (id, body) => client.post(p(`/plaene/${id}/tage`), body),
    tag: (id, key, body) => client.patch(p(`/plaene/${id}/tage/${key}`), body),
    tagWeg: (id, key, version) => client.delete(p(`/plaene/${id}/tage/${key}`), { params: { version } }),
    reihenfolge: (id, version, keys) => client.put(p(`/plaene/${id}/tage-reihenfolge`), { version, keys }),
    ablauf: (id, body) => client.patch(p(`/plaene/${id}/ablauf`), body),
    block: (id, body) => client.patch(p(`/plaene/${id}/block`), body),
    vorlagen: (archiv = false) => client.get(p('/plan-vorlagen'), { params: archiv ? { archiv: true } : undefined }),
    vorlageArchivieren: (vid, archiviert = true) => client.patch(p(`/plan-vorlagen/${vid}`), { archiviert }),
    bibliothek: (params) => client.get(p('/bibliothek-filter'), { params }),
    personPlaene: (lid) => client.get(p(`/personen/${lid}/plaene`)),
    standard: (lid, zyklus_id) => client.put(p(`/personen/${lid}/standard`), { zyklus_id }),
    auswahl: (lid, body) => client.patch(p(`/personen/${lid}/auswahl`), body),
    programme: (archiv = false) => client.get(p('/programme'), { params: archiv ? { archiv: true } : undefined }),
    programmNeu: (body) => client.post(p('/programme'), body),
    programmAendern: (pid, body) => client.patch(p(`/programme/${pid}`), body),
    personProgramm: (lid) => client.get(p(`/personen/${lid}/programm`)),
    zuweisen: (lid, body) => client.post(p(`/personen/${lid}/programm`), body),
    beenden: (pzid) => client.post(p(`/programm-zuweisungen/${pzid}/beenden`)),
  };
}

export const TAGESTYP = { training: 'Training', zirkel: 'Zirkel', hiit: 'HIIT', restday: 'Restday' };
export const ROLLE = { haupt: 'Mainlift', zubringer: 'Zubringer', power1: 'Power', power2: 'Power', conditioning: 'Conditioning' };
export const SLOTS = ['haupt', 'zubringer', 'power1', 'power2', 'conditioning'];
export const WOCHENTAGE = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
